import React, { useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const JsonViewerTool = () => {
  const [jsonInput, setJsonInput] = useState("");
  const [jsonOutput, setJsonOutput] = useState("Output Here");

  const formatJSON = () => {
    try {
      const formattedJson = JSON.stringify(JSON.parse(jsonInput), null, 2);
      setJsonOutput(formattedJson);
    } catch (error) {
      setJsonOutput("Invalid JSON");
    }
  };

  return (
    <>
    <Header />
    <div className="full-div" id="blog">
      <Container fluid className="main-sec">
        <Row className="mt-5 mb-5">
          <Col sm={2}></Col>
          <Col sm={7} className="bg-white p-4 div-shadow mb-3">
            <h1 className="head-color">JSON Viewer Tool</h1>
            <span className="small ms-2">
              <b>Publish By:-</b> CodeInputs
            </span>
            <p className="mt-4 blacktext">
              Paste your JSON data below and click "Format JSON" to visualize it.
            </p>
            <Form.Control
              as="textarea"
              id="jsonInput"
              placeholder="Paste JSON here..."
              value={jsonInput}
              onChange={(e) => setJsonInput(e.target.value)}
              rows={5}
            />
            <div className="d-grid col-md-6 mt-3">
              <Button variant="warning" onClick={formatJSON}>
                Format JSON
              </Button>
            </div>
            <h2 className="mt-3 mb-3">Formatted JSON:</h2>
            <pre id="jsonOutput" className="bg-light p-3 border rounded">
              {jsonOutput}
            </pre>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
    </>
  );
};

export default JsonViewerTool;
